<template>
  <div>
    <el-dialog :title="$t('public53')" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialog.edit" width="25%" class="info-dialog">
      <div class="idcard-info">
        <div class="info-title">
          <I18Lang id="user57" defaultText="Identity Information" />
        </div>

        <div class="bank-card-view">
          <div class="bank-card">
            <Upload @fileChange="frontIDCard" file_directory="auth">
              <div class="upload-view">
                <img v-if="formData.id_pic_a_url" :src="formData.id_pic_a_url" alt="" />
                <img v-else class="upload-img" src="@/assets/img/szz.png" alt="" />
              </div>
            </Upload>
          </div>

          <div class="bank-card">
            <Upload @fileChange="reverseIDCard" file_directory="auth">
              <div class="upload-view">
                <img v-if="formData.id_pic_b_url" :src="formData.id_pic_b_url" alt="" />
                <img v-else class="upload-img" src="@/assets/img/szf.png" alt="" />
              </div>
            </Upload>
          </div>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
          <I18Lang id="user84" defaultText="提交" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Upload from '@/components/Upload/Upload.vue'
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('user25'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        callback()
      }
    }

    return {
      dialog: {
        edit: false
      },
      formData: {
        id_pic_a_url: '',
        id_pic_b_url: ''
      },
      rules: {
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        old_password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Upload
  },
  methods: {
    showDialog () { // 修改类型
      this.formData.id_pic_a_url = this.userInfo.bank_info ? this.userInfo.bank_info.id_pic_a_url : ''
      this.formData.id_pic_b_url = this.userInfo.bank_info ? this.userInfo.bank_info.id_pic_b_url : ''
      this.dialog.edit = true
    },
    frontIDCard (file) { // 身份证正面
      this.formData.id_pic_a_url = file
    },
    reverseIDCard (file) { // 身份证正面
      this.formData.id_pic_b_url = file
    },
    submitForm () {
      this.$http.post('/api/user/editBankInfo', { ...this.userInfo.bank_info, ...this.formData }).then(result => {
        this.$alert(this.$t('public62'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
            this.$emit('onUpdata')
            this.dialog.edit = false
          }
        })
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 530px !important;
    min-height: 400px;
    height: 400px;
    background: url("../../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .info-title {
      font-size: 16px;
      font-weight: normal;
      color: #01B2F5;
      line-height: 41px;
    }

    .bank-card-view {
      display: flex;
      justify-content: space-between;
    }

    .upload-view {
      img {
        width: 238px;
        height: 133px;
        border: 1px solid rgba(1, 178, 245, 0.5);
      }
    }
  }
}
</style>
